import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withFirebase } from 'react-redux-firebase';
import { createStructuredSelector } from 'reselect';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { appKeysSelector } from '@selectors/global';
import * as globalActions from '@actions/global';

import ReloadModal from '../ReloadModal/ReloadModal';

class DeploymentWatch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenRefresh: false,
    };
  }

  componentDidMount() {
    const { appKeys, firebase } = this.props;

    if (appKeys.getIn(['generalConfig', 'autoRefreshEnabled'])) {
      firebase
        .database()
        .ref('appInfo/deployment')
        .on('value', this.onDeploymentUpdate);
    }
  }

  componentWillUnmount() {
    const { appKeys, firebase } = this.props;

    if (appKeys.getIn(['generalConfig', 'autoRefreshEnabled'])) {
      firebase
        .database()
        .ref('appInfo/deployment')
        .off('value', this.onDeploymentUpdate);
    }
  }

  onDeploymentUpdate = deployment => {
    const version = deployment.child('version').val();
    const deployGitSHA = this.props.appKeys.getIn([
      'generalConfig',
      'deployGitSHA',
    ]);

    if (version && deployGitSHA && version !== deployGitSHA) {
      this.setState({ isOpenRefresh: true });
    }

    this.props.setDeployGitSHA(version);
  };

  render() {
    return (
      <ReloadModal
        isOpen={this.state.isOpenRefresh}
        onClose={() => this.setState({ isOpenRefresh: false })}
      />
    );
  }
}

DeploymentWatch.propTypes = {
  appKeys: ImmutablePropTypes.map,
  firebase: PropTypes.object,
  setDeployGitSHA: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  appKeys: appKeysSelector,
});

const mapDispatchToProps = {
  setDeployGitSHA: globalActions.setDeployGitSHA,
};

const enhance = compose(
  withFirebase,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(DeploymentWatch);
